<div class="modal-content">
    <div class="modal-header border-0">
        <button type="button" class="btn-close" (click)="modal.dismissAll()"></button>
    </div>
    <div class="modal-body p-4">
        <div class="tab-content" id="v-pills-tabContent">
            <div class="tab-pane contact-tab-0 tab-content-child fade show active" id="v-pills-user" role="tabpanel"
                 aria-labelledby="v-pills-user-tab">
                <div class="profile-mail">
                    <div class="d-flex">
                        <img class="img-fluid m-r-20 rounded-circle update_img_0" src="assets/img/backlog/address.png" alt="">
                        <input class="updateimg" type="file">
                        <div class="flex-grow-1 mt-0">
                            <h3><span class="first_name_0">Datos Personales</span>
                            </h3>
                            <p class="email_add_0">{{title}}</p>
                        </div>
                    </div>

                    <div class="email-general">
                        <h6 class="mb-3"></h6>
                        <ul class="list-unstyled">
                            <li class="d-flex justify-content-between">
                                <span>Nombre</span>
                                <span class="font-primary first_name_0">{{personalData.name}}</span>
                            </li>
                            <li class="d-flex justify-content-between">
                                <span>Telefóno</span>
                                <span class="font-primary city_0">{{personalData.phone}}</span>
                            </li>
                        </ul>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>
